import type { Xinglet } from '@xing-com/crate-xinglet';

import { ReducedJobDetails } from './reduced-job-details';

export default class ReducedJobDetailsXinglet implements Xinglet {
  public getComponent(): React.ComponentType {
    return () => <ReducedJobDetails />;
  }
}
